"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var materialColor_native_exports = {};
__export(materialColor_native_exports, {
  Material3Color: () => Material3Color,
  Material3DynamicColor: () => Material3DynamicColor
});
module.exports = __toCommonJS(materialColor_native_exports);
var import_react_native = require("react-native");
var { One } = import_react_native.NativeModules;
function Material3DynamicColor(name) {
  if (import_react_native.Platform.OS !== "android" || !One) return null;
  var scheme = import_react_native.Appearance.getColorScheme();
  return One.Material3DynamicColor(name, scheme !== null && scheme !== void 0 ? scheme : "unspecified");
}
function Material3Color(name) {
  if (import_react_native.Platform.OS !== "android" || !One) return null;
  var scheme = import_react_native.Appearance.getColorScheme();
  return One.Material3Color(name, scheme !== null && scheme !== void 0 ? scheme : "unspecified");
}
//# sourceMappingURL=materialColor.native.js.map
